import styled from 'styled-components';
import { Select, Input } from 'antd';

export const TableContent = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const TableScrollArea = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
`;

export const StyledFiltersSection = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  text-transform: capitalize;
`;

export const FiltersGroup = styled.div`
  display: flex;
  gap: 10px;
`;

export const FilterSelect = styled(Select)`
  width: 200px;
`;

export const FilterInput = styled(Input)`
  width: 200px;
`;

export const CapitalizedText = styled.span`
  text-transform: capitalize;
`;

export const ActionsCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: nowrap;
`;
